import * as React from 'react';
import s from '../../solution-page-views/solution-info/solution-info.scss';
import Languages from 'wix-ui-icons-common/Languages';
import { composer } from '../../../../component-decorators/composer';
import { PreviewMode } from '../preview-context';
import { Box, TextButton } from 'wix-style-react';
export var DevSiteLinkWrapper = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(PreviewMode.Consumer, null, function (value) {
        return value.isPreview && !props.href ? (React.createElement(Box, { verticalAlign: "middle", paddingTop: 1, paddingBottom: 1, className: s.devCardLinkContainer },
            React.createElement(TextButton, { size: "medium", dataHook: "developer-email-link", prefixIcon: React.createElement(Languages, null), as: "a", href: "https://dev.wix.com/dc3/my-apps/" + value.appId + "/market/info/basic-info" }, props.t('solution.page.preview.addWebSiteURl')))) : (React.createElement("div", null, props.children));
    }));
});
//# sourceMappingURL=dev-site-wrapper.js.map